import Base from './base'
import Request from '@utils/request'

class TaskRecord extends Base {
  async create (data) {
    const response = await Request.post('/api/task-records', data)
    return response
  }

  async delete (id) {
    const response = await Request.delete(`/api/task-records/${id}`)

    return response
  }
}

export default new TaskRecord()
